import React from 'react';
import { Backdrop, Box, Typography, Button, Stack } from '@mui/material';
import LocationOffIcon from '@mui/icons-material/LocationOff';

export default function ErrorOverlay({ open, message, onClose, onChangeAddress }) {
  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: 2000,
        flexDirection: 'column',
        bgcolor: 'rgba(255, 253, 248, 0.95)', // Warm premium background, slightly transparent
        backdropFilter: 'blur(8px)',
      }}
    >
      <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', px: 3, maxWidth: '400px' }}>
        
        {/* Animated Error Circle */}
        <Box sx={{ position: 'relative', width: 120, height: 120, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 4 }}>
          
          {/* Pulsing Red Ring */}
          <Box
            sx={{
              position: 'absolute',
              width: '100%', height: '100%',
              borderRadius: '50%',
              border: '2px solid #E85D3F',
              opacity: 0,
              animation: 'errorPulse 2s infinite',
              '@keyframes errorPulse': {
                '0%': { transform: 'scale(0.8)', opacity: 0.8 },
                '100%': { transform: 'scale(1.5)', opacity: 0 }
              }
            }}
          />

          {/* Central Error Circle */}
          <Box
            sx={{
              position: 'relative',
              width: 90, height: 90,
              borderRadius: '50%',
              bgcolor: 'rgba(232, 93, 63, 0.1)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 8px 24px rgba(232, 93, 63, 0.2)',
              animation: 'popIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards',
              '@keyframes popIn': {
                '0%': { transform: 'scale(0)' },
                '100%': { transform: 'scale(1)' }
              }
            }}
          >
            {/* Shaking Icon */}
            <LocationOffIcon 
              sx={{ 
                fontSize: 40, 
                color: '#E85D3F',
                animation: 'shake 0.5s ease-in-out 0.5s',
                '@keyframes shake': {
                  '0%, 100%': { transform: 'translateX(0)' },
                  '20%, 60%': { transform: 'translateX(-5px)' },
                  '40%, 80%': { transform: 'translateX(5px)' }
                }
              }} 
            />
          </Box>
        </Box>

        {/* Text Content */}
        <Typography
          variant="h5"
          fontWeight="900"
          sx={{ color: '#3A2C23', mb: 1.5, animation: 'fadeInUp 0.6s ease 0.3s both' }}
        >
          Out of Delivery Zone
        </Typography>

        <Typography
          variant="body1"
          sx={{ color: '#6E655E', fontWeight: '600', mb: 4, lineHeight: 1.6, animation: 'fadeInUp 0.6s ease 0.4s both' }}
        >
          {message || "Sorry, we don't deliver to this location yet."}
        </Typography>

        {/* Action Buttons */}
        <Stack direction="row" spacing={2} sx={{ width: '100%', animation: 'fadeInUp 0.6s ease 0.5s both' }}>
          <Button
            fullWidth
            variant="outlined"
            onClick={onClose}
            sx={{ 
              borderRadius: '16px', py: 1.5, color: '#6E655E', borderColor: '#ECE5DA', fontWeight: '800', textTransform: 'none',
              '&:hover': { borderColor: '#E85D3F', color: '#E85D3F', bgcolor: 'transparent' }
            }}
          >
            Cancel
          </Button>
          <Button
            fullWidth
            variant="contained"
            disableElevation
            onClick={onChangeAddress}
            sx={{ 
              borderRadius: '16px', py: 1.5, bgcolor: '#F8C332', color: '#3A2C23', fontWeight: '800', textTransform: 'none',
              boxShadow: '0 4px 12px rgba(248, 195, 50, 0.3)',
              '&:hover': { bgcolor: '#F5B71D' }
            }}
          >
            Change Address
          </Button>
        </Stack>
      </Box>

      {/* Shared Keyframes */}
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(15px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </Backdrop>
  );
}